export function parseStringToNumberOrUndefined(val: string): number | undefined {
    if (val === undefined) return undefined;

    let trimmed: string = val?.trim();
    if (trimmed === '') return undefined;

    /** if number has . and , example: 1,000.25 - remove all commas */
    if (trimmed.includes(',') && trimmed.includes('.')) {
        trimmed = trimmed.replaceAll(',', '');
    }

    /** if number has one , and no dots, example: 1,25 - convert it to dot */
    const commasCount = trimmed.split(',').length - 1;
    const dotsCount = trimmed.split('.').length - 1;
    if (commasCount === 1 && dotsCount === 0) {
        trimmed = trimmed.replace(',', '.');
    }

    const parsed = Number(trimmed);
    if (!Number.isNaN(parsed) && Number.isFinite(parsed)) return parsed;
    return undefined;
}
